export const formatNumberWithCommas = (value) => {
  if (!value) {
    return;
  }

  if (value === 'nan') {
    return 'TMU';
  }

  if (value) {
    return Math.floor(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  return 0;
};
